"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemFuturesEnabledReducer = void 0;
var _actions = require("../actions");
var systemFuturesEnabledReducer = exports.systemFuturesEnabledReducer = function systemFuturesEnabledReducer() {
  var _action$payload$syste, _action$payload;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actions.RECEIVE_SYSTEM_FUTURES_ENABLED:
      return (_action$payload$syste = action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.systemFuturesEnabled) !== null && _action$payload$syste !== void 0 ? _action$payload$syste : state;
    default:
      return state;
  }
};